import React from 'react';
import PropTypes from 'prop-types';
import { BreadcrumbJsonLd } from 'next-seo';

const BreadCrumb = ({
  domain, title, pathname, baseBreadcrumb,
}) => {
  const breadCrumbListItem = [{
    position: 2,
    item: `${domain}${pathname}`,
    name: title,
  }];

  const extraBreadCrumb = title ? breadCrumbListItem : [];
  const completeBreadCrumbList = [...baseBreadcrumb, ...extraBreadCrumb];

  return (
    <BreadcrumbJsonLd
      itemListElements={completeBreadCrumbList}
    />
  );
};

BreadCrumb.defaultProps = {
  title: null,
};

BreadCrumb.propTypes = {
  baseBreadcrumb: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.string,
      name: PropTypes.string,
      position: PropTypes.number,
    }),
  ).isRequired,
  domain: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default BreadCrumb;
